import { Box, Step, StepButton, Stepper, styled } from '@mui/material';
import { useNavigate } from 'react-router';
import { CITYSPRINT_STEP_ROUTES, CITYSPRINT_STEPS } from '../constants';

const StyledStepper = styled(Stepper)(({ theme }) => ({
  justifyContent: 'center',
  '& .MuiStepIcon-root': {
    display: 'none',
  },
  '& .MuiStepConnector-root': {
    width: '71px',
    flexGrow: 0,
    [theme.breakpoints.down('md')]: {
      width: '53px',
    },
  },
  '& .MuiStepLabel-label.Mui-active': {
    color: theme.palette.primary.main,
  },
}));

export function CitysprintFlowStepper({
  activeStep,
  onBeforeNavigate,
  interceptNavigate,
  maxReachableStep = 2,
}) {
  const navigate = useNavigate();

  return (
    <Box sx={{ width: '100%', mb: 2 }}>
      <StyledStepper activeStep={activeStep} nonLinear>
        {CITYSPRINT_STEPS.map(({ key, label }, stepIndex) => {
          const canOpenStep = stepIndex <= maxReachableStep;
          return (
            <Step key={key}>
              <StepButton
                id={`citysprint-flow-nav-${key}`}
                color='inherit'
                disabled={!canOpenStep}
                onClick={() => {
                  if (!canOpenStep) {
                    return;
                  }
                  onBeforeNavigate?.(key);
                  if (interceptNavigate?.(key)) {
                    return;
                  }
                  navigate(CITYSPRINT_STEP_ROUTES[key]);
                }}
              >
                {label}
              </StepButton>
            </Step>
          );
        })}
      </StyledStepper>
    </Box>
  );
}
